<template lang="pug">
v-select.round-xl(v-model="modelValue" :items="items" :item-text="itemText" :item-value="itemValue" :placeholder="placeholder" dense outlined :rules="rules" :hide-details="hideDetails" :loading="loading" @change="change" append-icon="$yzi-chevron-down" :menu-props="{ bottom: (menuPosition === 'bottom'), top: (menuPosition === 'top'), offsetY: true, rounded: 'lg', contentClass: 'select-menu', maxHeight: menuHeight }" :class="[className, selectStyle]" :height="getHeight" :no-data-text="noDataText" :attach="attach" :disabled="disabled" :background-color="disabled ? 'neutral300' : backgroundColor || ''" :return-object="returnObject")
  template(#append-item)
    slot(name="append-item")
</template>

<script>
export default {
  props: {
    value: {
      default: undefined
    },
    items: {
      default: undefined
    },
    itemText: {
      default: null
    },
    itemValue: {
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    rules: {
      type: Array,
      default: () => ([])
    },
    loading: {
      type: Boolean,
      default: false
    },
    attach: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: null
    },
    small: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean
    },
    noDataText: {
      default: '$vuetify.noDataText'
    },
    menuHeight: {
      type: String,
      default: '304'
    },
    menuPosition: {
      type: String,
      default: 'bottom'
    },
    hideDetails: {
      default: 'auto'
    },
    backgroundColor: {
      default: null
    },
    returnObject: {
      type: Boolean
    }
  },
  computed: {
    modelValue: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    },
    getHeight () {
      if (this.small) {
        return null
      }
      return 48
    },
    selectStyle () {
      return this.small ? '' : 'normal'
    }
  },
  methods: {
    change () {
      this.$emit('change')
    }
  }
}
</script>

<style scoped>
.error--text >>> fieldset {
  border-color: var(--v-danger);
}

.normal ::v-deep .v-input__icon {
  min-width: 22px;
  width: 22px;
  margin-top: 4px;
}
</style>